function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.drawer = document.getElementById('cart-drawer');
    
    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));

    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));

    this.cartClose = document.querySelectorAll('.js-close-cart');
    this.cartClose.forEach( c => {
      c.addEventListener('click', this.close.bind(this));
    })
    
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.pageOverlayElement = document.querySelector('.page-overlay');

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));


    this.initUpsells()
  }

  initUpsells() {
    this.upsells = this.querySelector(".cart-upsells")

    if (this.upsells){
      const swiper = new Swiper(this.upsells, {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    }

    this.upsellATC = this.querySelectorAll("[data-add-upsell]")
    this.upsellATC.forEach(_b => {
      _b.addEventListener("click", this.addUpsell.bind(this))
    })
  }

  open() {
    this.setAttribute('aria-hidden', false);
    this.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.classList.add("prevent-scroll")
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.setAttribute('aria-hidden', true);
    this.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.classList.remove("prevent-scroll")
    document.body.removeEventListener('click', this.onBodyClick);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  addUpsell(event){
    event.preventDefault();
    this.enableLoading()

    const id = event.target.dataset.id

    const body = JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1,
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          console.log(section, typeof section.id)

          if(typeof section.id == 'string'){
            const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          } else {
            section.id.forEach(id => {
              const elementToReplace = document.getElementById(id).querySelector(section.selector) || document.getElementById(id);

              const newInnerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${id}` )

              elementToReplace.innerHTML = newInnerHTML
            })
          }

        }));

        this.disableLoading();
        this.initUpsells()
      }).catch(() => {
        this.disableLoading();
      });

  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {

          if(typeof section.id == 'string'){
            const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          } else {
            section.id.forEach(id => {
              const elementToReplace = document.getElementById(id).querySelector(section.selector) || document.getElementById(id);

              const newInnerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${id}` )

              elementToReplace.innerHTML = newInnerHTML
            })
          }

        }));

        this.disableLoading();
        this.initUpsells()
      }).catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: ['cart-drawer__content', 'cart-drawer__footer'],
        section: document.getElementById('cart-drawer__content').dataset.id
      },
      {
        id: ['cart-icon-bubble', 'cart-drawer-count', 'cart-subtotal-count'],
        section: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById('cart-drawer-loading') && document.getElementById('cart-drawer-loading').classList.remove('hidden');
  }

  disableLoading() {
    document.getElementById('cart-drawer-loading') && document.getElementById('cart-drawer-loading').classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay') || target == this) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);
